import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationLocationBlConstants {
    static STEP_TITLE = "Location";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static COPY_APPLICANT_TO_OWNER_LABEL = "Copy applicant to owner";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that the zoning here is the current zoning of the property. Please note that an owner should be added for each property (this is linked to the property and the application).";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static UNIT_NUMBER_CONTROL = "unitNumber";
    static SHOP_NUMBER_CONTROL = "shopNumber";
    static TITLE_DEED_NUMBER_CONTROL = "titleDeedNumber";
    static TITLE_DEED_DESCRIPTION_CONTROL = "titleDeedDescription";
    static ACCOMMODATION_NAME_CONTROL = "accommodationName";
    static UNIT_NUMBER_LABEL = "Unit no";
    static SHOP_NUMBER_LABEL = "Shop no";
    static TITLE_DEED_NUMBER_LABEL = "Title deed number";
    static TITLE_DEED_DESCRIPTION_LABEL = "Title deed description";
    static ACCOMMODATION_NAME_LABEL = "Name of accommodation establishment";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        unitNumber: {
            required: `Unit No ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        shopNumber: {
            required: `Required: ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeedNumber: {
            required: `Title Deed Number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeedDescription: {
            required: `Title Deed Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        accommodationName: {
            required: `Name of accommodation establishment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
    static PROPERTY_REQUIRED = "Please select a property before continuing with the create application process";
    static MODAL_OPTION = {
        size: SharedConstants.MODAL_SIZE.extraLarge,
        centered: true,
        backdrop: "static",
        keyboard: false
    };
}
